import { render, staticRenderFns } from "./TotalTurnoverBonus.vue?vue&type=template&id=007ad5fe"
import script from "./TotalTurnoverBonus.vue?vue&type=script&lang=js"
export * from "./TotalTurnoverBonus.vue?vue&type=script&lang=js"
import style0 from "./TotalTurnoverBonus.vue?vue&type=style&index=0&id=007ad5fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports